import { isEmpty } from "lodash-es";

import * as catalogService from "@/services/catalogService/tracks";

type VideoIdOrder = number | string | string[];

export async function getVideoRouteDetails(to: any) {
  let c1 = false;
  let c2 = false;
  let route: any = {};
  const trackID = to.params.videoSerieId;
  let videoIdOrder: VideoIdOrder = to.params.videoId;

  if (!trackID) {
    c1 = true;
  } else if (isValidVideoIdOrder(videoIdOrder)) {
    // Valid video order, no further processing needed
  } else {
    const result = await handleInvalidVideoOrder(trackID, videoIdOrder);
    c1 = result.c1;
    c2 = result.c2;
    videoIdOrder = result.videoIdOrder;
  }

  route = buildRoute(c1, c2, to, trackID, videoIdOrder);
  return { c1, c2, route };
}

async function handleInvalidVideoOrder(
  trackID: string,
  videoIdOrder: VideoIdOrder
) {
  try {
    const data = await catalogService.fetch(trackID);

    if (data.active === 0 || data.Courses.length === 0) {
      return { c1: true, c2: false, videoIdOrder };
    }

    const newVideoIdOrder = generateVideoIdOrder(data, videoIdOrder);
    return newVideoIdOrder === ""
      ? { c1: true, c2: false, videoIdOrder }
      : { c1: false, c2: true, videoIdOrder: newVideoIdOrder };
  } catch (error) {
    if (!import.meta.env.TEST) {
      console.error("Error fetching track data:", error);
    }
    return { c1: true, c2: false, videoIdOrder };
  }
}

function buildRoute(
  c1: boolean,
  c2: boolean,
  to: any,
  trackID: string,
  videoIdOrder: VideoIdOrder
) {
  if (c1) {
    return { name: "explore-videos" };
  }

  if (c2) {
    return {
      name: to.name,
      params: { videoSerieId: trackID, videoId: videoIdOrder },
      query: to.query,
    };
  }

  return {};
}

export function isValidVideoIdOrder(videoIdOrder: VideoIdOrder): boolean {
  return (
    !isEmpty(videoIdOrder) &&
    startsWithVideoOrderPrefix(videoIdOrder.toString())
  );
}

export function startsWithVideoOrderPrefix(str: string): boolean {
  const regex = new RegExp(String.raw`^${"video-"}\d{2}-`);
  return regex.test(str);
}

export function generateVideoIdOrder(
  data: any,
  videoIdOrder: VideoIdOrder
): string {
  let videoId = videoIdOrder;
  if (isEmpty(videoIdOrder)) {
    videoId = data.Courses[0].friendly_url || data.Courses[0].id;
  }
  const order = data.Courses.findIndex(
    (course: any) =>
      course.friendly_url == `${videoId}` || `${course.id}` == `${videoId}`
  );
  if (order == -1) return "";
  const videoOrder = order < 9 ? `0${order + 1}` : `${order + 1}`;
  return `video-${videoOrder}-${videoId}`;
}
